import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const PrivateRoute = () => {
  const location = useLocation();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let mounted = true;

    const validarAcceso = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        mounted && setStatus("invalidToken");
        return;
      }

      const ruta = location.pathname.toLowerCase();


      try {
        const res = await axios.post(
          process.env.REACT_APP_VALIDARAC,
          { ruta },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        mounted && setStatus(res.data?.success ? "authorized" : "unauthorized");
      } catch (e) {
        if (!mounted) return;

        if (e.response?.status === 401) setStatus("invalidToken");
        else if (e.response?.status === 403) setStatus("unauthorized");
        else setStatus("authorized"); // fallo de red → permitir
      }
    };

    validarAcceso();
    return () => (mounted = false);
  }, [location.pathname]);

  if (status === "loading") return <div>Cargando...</div>;

  if (status === "invalidToken") {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  if (status === "unauthorized") {
    return <Navigate to="/no-autorizado" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
